"use strict";

import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Route, Router, Switch } from "react-router-dom";

import {
  builderIOInit,
  fbPixel,
  gtmDataLayerPush,
  identifyUser,
  posthogInit,
  posthogStartSessionRecording,
} from "../shared/utils/analytics";
import { bugsnagClient } from "../shared/utils/errorHandling";

import { ApolloClient, ApolloProvider, createHttpLink } from "@apollo/client";
import { InMemoryCache } from "@apollo/client/cache";
import { setContext } from "@apollo/client/link/context";
import { rolloutRetryLink } from "../shared/utils/rolloutRetryLink";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import theme from "../shared/styles/muiTheme.js";

// Loads Stripe.js on every page of the visit/checkout bundle, not just the payment
// step. Stripe's advanced fraud signals need the script present across the session to
// profile the device; loading it only at confirm time gives Radar a single data point.
// Verified: on /visits/:type/signup this pulls m.stripe.network and sets __stripe_mid.
//
// This is for Radar SCORING only -- it does not feed chargeback representment. Radar's
// fingerprint stays inside Stripe: the API never returns it, and radar_options carries
// only a per-payment session id that is a different value on every checkout, so it
// could never match a prior transaction the way Visa Compelling Evidence 3.0 requires.
// The kick_did cookie is what populates the CE3.0 device elements -- see
// app/request_identity_middleware.go and docs/chargeback-evidence.md.
//
// Keeping it is still right: preventing a fraudulent charge is worth more than
// defending it afterwards.
// https://github.com/stripe/stripe-js#ensuring-stripejs-is-available-everywhere
import "@stripe/stripe-js";

import "../shared/styles/global-base.css";
import "../shared/styles/material-dashboard-overrides.css";

import indexRoutes from "./routes/index.js";

const httpLink = createHttpLink({
  uri: "/me/gql/graphql",
  credentials: "same-origin",
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const apolloClient = new ApolloClient({
  link: rolloutRetryLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache(),
});

builderIOInit();

posthogInit();
identifyUser();
posthogStartSessionRecording();

const hist = createBrowserHistory();
hist.listen((location) => {
  // console.log("location:", location);

  // if (window.dataLayer) {
  //   window.dataLayer = window.dataLayer || [];
  //   window.dataLayer.push({
  //     event: "Pageview",
  //     path: location.pathname
  //     // formLocation: "footer"
  //   });
  // }

  gtmDataLayerPush({
    event: "pageview",
    path: location.pathname,
  });

  fbPixel("PageView");

  // if (window.fbq) {
  //   window.fbq("track", "PageView");
  // }
});

const ErrorBoundary = bugsnagClient.getPlugin("react");

ReactDOM.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <ApolloProvider client={apolloClient}>
          <Router history={hist}>
            <Switch>
              {indexRoutes.map((prop, key) => {
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </Router>
        </ApolloProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </StyledEngineProvider>,
  document.getElementById("visits_container"),
);
